module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && !_vm.isExpert && _vm.showAd) ? _c('div', {
    staticClass: "adtip"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-track": "djk_kj_download_close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": _vm.download
    }
  }, [_c('div', {
    staticClass: "go",
    attrs: {
      "data-track": "djk_kj_download_go"
    }
  }, [_c('h2', [_vm._v("宝宝树孕育")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('span', {
    staticClass: "download"
  }, [_vm._v("立即下载")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db49b9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdTip.vue
// module id = 1085
// module chunks = 85